import * as $ from 'jquery';
import 'bootstrap';

export class tabContent {
	$scope: any = $('.tab-content--container');
	tabComponent(): void {
		let _self = this;
		let $menuItem: any = _self.$scope.find('ul.nav-tabs li a');
		$menuItem.on('touchstart mouseenter focus', function(e:any) {
				if(e.type == 'touchstart') {
						// Don't trigger mouseenter even if they hold
						e.stopImmediatePropagation();
						// If $item is a link (<a>), don't go to said link on mobile, show menu instead
						// e.preventDefault();
				}
		});


		let $viewportWidth:any = $(window).width();
		$(window).load(function() {
			if($viewportWidth < 767){
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 3){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			} else {
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 7){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			}
		});
	}
}

let scope:Element = document.querySelector('.tab-content--container');
if (scope){
	try {
		let tabcontent = new tabContent();
				tabcontent.tabComponent();
	} catch(e) {console.error(e);}
}
